import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICellRendererParams } from 'ag-grid-community';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';

@Component({
  selector: 'piqet-angular-dropdown-report-config',
  templateUrl: './dropdown-report-config.component.html',
  styleUrls: ['./dropdown-report-config.component.css'],
})
export class DropdownReportConfigComponent {
  scenarioConfigList: any;
  params: any;
  from: any;
  processId: any;
  processList = [];
  bindLabel = '';
  placeHolder = 'Process *';
  scenarioId: any;

  constructor(public route: ActivatedRoute, private projectService: ProjectsService) {}

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: any): void {
    this.params = params;
    this.scenarioId = this.route?.snapshot?.queryParams['packageScenarioId'];
    this.from = params.from;
    if (this.from == 'orgReportingProcess') {
      this.processId = params.data.id;
      this.processList = params?.newDefalutOrgReportingList;
      this.bindLabel = 'description';
      if (this.params.colDef.colId == 'year') {
        this.placeHolder = 'Year *';
      } else {
        this.placeHolder = 'Product group *';
      }
    }
  }

  selectedData(eve: any, name?: any) {
    let year, productGroupdId;
    if (name == 'Year *') {
      year = eve?.description;
    } else if (name == 'Product group *') {
      productGroupdId = eve?.id;
    }
  }
}
